import React from 'react';
import serviceimg from '../../src/images/service/imgsm.png';

const Services = ({ header }) => {
  return (
    <section className="flex flex-col gap-3 items-center justify-center pt-10 h-[200px] w-full bg-banner">
      <div className="flex items-center gap-3 justify-center md:mx-0 mx-3">
        <img src={serviceimg} alt="service logo" />
        <h3 className="text-[#F0FFC5] font-semibold text-md">
          {header?.title || 'OUR SERVICES'}
        </h3>
      </div>
      <div className="md:mx-0 mx-3 text-center">
        <h2 className="text-[#FFFF] text-3xl font-bold">
          {header?.subtitle || 'Explore what we offer.'}
        </h2>
      </div>
    </section>
  );
};

export default Services;